module.exports = __webpack_public_path__ + "img/switch.d3aca062.png";